{
  "form": {
    "input_placeholder": "Ongeza kazi…",
    "parseWithAi_aria": "Changanua kazi kwa AI",
    "parseWithAi_title": "Safisha na weka kipaumbele kwa AI",
    "priorityLabel_aria": "Kipaumbele cha kazi",
    "add": "Ongeza",
    "signInForAi": "Ingia ili kutumia vipengele vya AI.",
    "aiUnavailable": "AI haipatikani. Jaribu tena.",
    "saveTo": "Hifadhi kwenye",
    "saveTo_aria": "Hifadhi kwenye {{list}}",
    "saveToSynced_aria": "Hifadhi kwenye {{list}}, {{provider}}",
    "addedTo": "Imeongezwa kwenye {{list}}",
    "addedToSynced": "Imeongezwa kwenye {{list}} · {{provider}}",
    "show": "Onyesha"
  },
  "priority": {
    "Critical": "Muhimu Sana",
    "High": "Juu",
    "Medium": "Wastani",
    "Low": "Chini"
  },
  "item": {
    "edit_aria": "Hariri kazi",
    "delete_aria": "Futa kazi",
    "addStep": "Ongeza hatua",
    "addStep_placeholder": "Ongeza hatua…",
    "addStep_aria": "Ongeza hatua kwenye {{task}}",
    "steps_group_aria": "Hatua za {{task}}",
    "steps_progress_aria": "Hatua {{done}} kati ya {{count}} zimekamilika",
    "completeSteps_aria": "{{task}}. Pia itakamilisha hatua {{count}} zilizo wazi"
  },
  "list": {
    "title": "Kazi",
    "newListFallback": "Orodha Mpya",
    "completedMeta": "{{completed}} kati ya {{total}} zimekamilika",
    "deleteConfirm": "Futa \"{{name}}\"?",
    "rename_title": "Badilisha jina",
    "deleteList_title": "Futa orodha",
    "newListName_placeholder": "Jina la orodha…",
    "newList": "Orodha mpya",
    "done": "Imekamilika",
    "emptyTitle": "Bado hakuna kazi",
    "emptySubtitle": "Ongeza moja hapa chini ili kuanza.",
    "noFilterMatch": "Hakuna kazi inayolingana na kichujio hiki.",
    "createIn": "Unda katika",
    "inDestination": "katika {{destination}}",
    "createIn_aria": "Unda katika {{destination}}",
    "createInAccount_aria": "Unda katika {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Inaunda katika {{destination}}…",
    "createFailed": "Imeshindwa kuunda “{{name}}” katika {{destination}}.",
    "createLimit": "{{destination}} imefikia kikomo cha orodha.",
    "keepInRhemn": "Baki katika Rhemn"
  },
  "filter": {
    "label": "Chuja",
    "all": "Zote"
  },
  "voice": {
    "mic_aria": "Ongeza kazi kwa sauti",
    "mic_title": "Taja kazi zako — zitapangwa kwa kipaumbele na wakati",
    "stop_aria": "Simamisha na upange kazi",
    "recording": "Inarekodi",
    "sorting": "Inapanga kazi zako…",
    "stripTitle": "Kazi zilizosikika",
    "stripCount": "{{checked}} kati ya {{total}}",
    "discard": "Tupa",
    "addN": "Ongeza {{count}}",
    "addZero": "Ongeza",
    "adding": "Inaongeza…",
    "parseFallback": "Imeshindwa kupanga — maneno yako yamo kwenye kisanduku.",
    "nothingHeard": "Haikusikika — jaribu tena.",
    "micDenied": "Maikrofoni imezuiwa — ruhusu kwenye mipangilio.",
    "gateBody": "Taja kazi zako — zapangwa kwa kipaumbele na kipindi cha swala. Ndani ya Pro.",
    "listen_aria": "Inasikiliza — taja kazi zako"
  }
}
